module.exports = __webpack_public_path__ + "static/media/return-of-the-jedi-thumb.490bb667.png";